// extracted by mini-css-extract-plugin
module.exports = {"flag":"_b8d2736","flagContainer":"_7b9dba1"};